import client from './client';

const PATH = '/api/advertisements/advertisements/';

const list = (params = {}) => client.get(PATH, { params }).then((r) => r.data);
const detail = (id) => client.get(`${PATH}${id}/`).then((r) => r.data);

/** Build a multipart FormData payload for advertisement create/update. */
const toFormData = (payload) => {
  const fd = new FormData();
  const fields = [
    'name', 'mode', 'target_type', 'target_parivar_id', 'title', 'description', 'date', 'month_tithi',
    'cta_label', 'cta_url', 'start_at', 'end_at', 'priority',
  ];
  fields.forEach((key) => {
    if (payload[key] !== undefined && payload[key] !== null && payload[key] !== '') {
      fd.append(key, payload[key]);
    }
  });
  if (payload.image instanceof File) fd.append('image', payload.image, payload.image.name);
  if (payload.is_active !== undefined) fd.append('is_active', payload.is_active ? 'true' : 'false');
  return fd;
};

export const advertisementApi = {
  list,
  detail,

  create(payload, { onUploadProgress } = {}) {
    return client.post(PATH, toFormData(payload), { timeout: 0, onUploadProgress }).then((r) => r.data);
  },

  update(id, payload, { onUploadProgress } = {}) {
    return client.patch(`${PATH}${id}/`, toFormData(payload), { timeout: 0, onUploadProgress }).then((r) => r.data);
  },

  remove(id) {
    return client.delete(`${PATH}${id}/`).then((r) => r.data);
  },
};